import * as React from 'react';

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgPmVenmo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M32.111 6H1.89C.846 6 0 6.82 0 7.833v18.334C0 27.179.846 28 1.889 28H32.11C33.154 28 34 27.18 34 26.167V7.833C34 6.821 33.154 6 32.111 6Z",
  fill: "#0288FF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m12.213 23.619-1.65-12.348a.44.44 0 0 1 .393-.495l3.53-.352a.44.44 0 0 1 .48.375l1.103 7.708c.056.394.556.507.756.162 1.691-2.924 1.853-5.888 1.67-7.415a.468.468 0 0 1 .364-.519l3.641-.726a.423.423 0 0 1 .473.238c2.107 4.797-1.958 10.956-4.418 13.617a.428.428 0 0 1-.317.136h-5.589a.44.44 0 0 1-.436-.381Z",
  fill: "#fff"
})));

export { SvgPmVenmo as default };
